import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-venue-room-details',
  standalone: false,
  templateUrl: './venue-room-details.component.html',
  styleUrl: './venue-room-details.component.scss',
})
export class VenueRoomDetailsComponent {
  @Input() data: any;
  @Input() isVisible = false;
  @Output() closeModal = new EventEmitter<void>();

  handleCancel(): void {
    this.closeModal.emit();
  }
  // get mediaLinksDisplay(): string {
  //   return (
  //     this.data?.media_link_details?.map((m: any) => m.url).join(', ') ||
  //     'No media available'
  //   );
  // }

  get mediaLinksDisplay(): string[] {
  return this.data?.media_link_details?.map((m: any) => m.url) || [];
}

}
